const skin=[
    
{symptom:"pigmentedLesion",
displayAs:"Pigmented skin lesion",
questionGroup:"pigmented"
},

{symptom:"dermoscopyMelanoma",
displayAs:"Dermoscopy suggests melanoma",
questionGroup:"dermoscopy"
},

{symptom:"nodularMelanoma",
displayAs:"Appearance suggestive of nodular melanoma",
questionGroup:"skinLesion"
},


{symptom:"squamous",
displayAs:"Appearance suspicious of squamous cell carcinoma",
questionGroup:"skinLesion"
},


{symptom:"basal",
displayAs:"Appearances suspicious of basal cell carcinoma",
questionGroup:"skinLesion"
},


{symptom: "basalConcerning",
displayAs:"BCC with concerning site or size",
questionGroup:"skinLesion"
},

{
symptom:"bruising",
displayAs:"Unexplained bruising",
questionGroup:"skinLesion"
},


{symptom:"petechiae",
displayAs: "Unexplained petechiae",
questionGroup:"skinNoSize"
},

{symptom:"pruritis",
displayAs:"Pruritis",
questionGroup:"skinNoSize"
},
]


export default skin